module.exports = __webpack_public_path__ + "img/img_start.4b5731cc.png";